import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';
import { FormattedUTCDate } from '@swf/poker';

import {
  TXTCLI_1_hour,
  TXTCLI_1_minute,
  TXTCLI_N0_hours,
  TXTCLI_N0_minutes,
  TXTCLI_inN0
} from './ScheduledTime.messages.json';
import styles from './ScheduledTime.scss';

export interface StartTimeProps {
  startTime: string;
}

const ScheduledTime: React.FC<StartTimeProps> = ({ startTime }) => {
  const locale = useSelector(select.locale.get);

  const nowUTC = new Date().toLocaleString(locale, { timeZone: 'UTC' });
  const nowMs = new Date(nowUTC).getTime();
  const startTimeMs = new Date(`${startTime}`.replace(/-/g, '/')).getTime();
  const timeLeft = startTimeMs - nowMs;

  const hours = Math.floor(timeLeft / 1000 / 60 / 60);
  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);

  if (timeLeft < 0) {
    return null;
  }

  // If there are more than 8 hours till the start of the tournament, show date and time only
  if (hours > 8) {
    return (
      <span data-testid="scheduled-tourn-time">
        <FormattedUTCDate
          utcDate={startTime}
          options={{
            hour12: false,
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
          }}
        />
      </span>
    );
  }

  // If there are 0 hours left, show minutes only
  if (!hours) {
    return (
      <span data-testid="scheduled-tourn-time" className={styles.minutes}>
        <span className={styles.capitalize}>
          <Translation {...TXTCLI_inN0} values={{ 0: '' }} />
        </span>
        <Translation {...TXTCLI_N0_minutes} values={{ 0: minutes }} />
      </span>
    );
  }

  return (
    <span data-testid="scheduled-tourn-time">
      <span className={styles.capitalize}>
        <Translation {...TXTCLI_inN0} values={{ 0: '' }} />
      </span>
      {hours === 1 ? (
        <Translation {...TXTCLI_1_hour} />
      ) : (
        <Translation {...TXTCLI_N0_hours} values={{ 0: hours }} />
      )}
      <span>, </span>
      {minutes === 1 ? (
        <Translation {...TXTCLI_1_minute} />
      ) : (
        <Translation {...TXTCLI_N0_minutes} values={{ 0: minutes }} />
      )}
    </span>
  );
};
export default ScheduledTime;
